<template>
  <div>
    <b-modal ref="createOrderItemModal"
             :title="title" :no-close-on-backdrop="true">
      <b-row v-if="isNewItem">
        <b-col cols="4">
          <label>{{$t('labels.common.smart_search')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="11">
          <input class="form-control" v-model="searchData.text"
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 @keyup.enter="searchLot" :tabindex="1" placeholder="">
        </b-col>
        <b-col>
          <img src="../../assets/images/common-icons/icon_search.svg" @click="searchLot" height="20"
               :tabindex="2"
               :title="$t('buttons.common.search')">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.lots.lot_spec_descr')}}</label>
          <multiselect v-model="orderItemData.lot" :max-height="200" :tabindex="3"
                       placeholder="Choose lot" label="description" track-by="id" :options="lotsForSelect"
                       :show-labels="false"
                       @select="autoComplete"
                       :class="{ required: (!orderItemData.lot) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.wood')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.quality')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.humidity')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-model="orderItemData.wood" :max-height="200" :tabindex="5"
                       placeholder="Choose wood" label="name" track-by="id" :options="wood"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.wood || orderItemData.wood.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.quality" :max-height="200" :tabindex="6"
                       placeholder="Choose quality" label="name" track-by="id" :options="qualities_list"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.quality || orderItemData.quality.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.humidity" :max-height="200" :tabindex="7"
                       placeholder="Choose humidity" :options="humidity_list"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.humidity || orderItemData.humidity.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.profile')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.delivery_date')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.sale_order_nr')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-model="orderItemData.profile_desc" :max-height="200" :tabindex="8"
                       placeholder="Choose profile. descr." label="name" track-by="id" :options="profiles"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <datepicker v-model="orderItemData.delivery_term" lang="en" :first-day-of-week="1" :tabindex="9"
                      :class="{ required: (!orderItemData.delivery_term) }"
          ></datepicker>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.sales_order" :max-height="200" :tabindex="10"
                       placeholder="Choose sale order No" label="descriptor" track-by="id"
                       :options="salesOrders"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          {{$t('labels.common.nominal')}}
        </b-col>
        <b-col class="d-flex justify-content-center">
          {{$t('labels.common.real')}}
        </b-col>
        <b-col class="d-flex justify-content-center">
          {{$t('labels.common.stock')}}
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.thickness')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.thickness_nominal"
                 :tabindex="11" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.thickness_nominal) }"
                 :placeholder=thickness_limit>
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.thickness_actual"
                 :tabindex="14" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.thickness_stock"
                 :tabindex="17" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.width')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.width_nominal"
                 :tabindex="12" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.width_nominal) }"
                 :placeholder=width_limit>
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.width_actual"
                 :tabindex="15" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.width_stock"
                 :tabindex="18" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.length')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.length_nominal" @input="autoCompleteLength"
                 :tabindex="13" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.length_nominal) }"
                 :placeholder=length_limit>
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.length_actual"
                 :tabindex="16" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.length_stock"
                 :tabindex="19" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.ordered')}}</label>
        </b-col>
        <b-col cols="4">
        </b-col>
        <b-col cols="4">
          <label>{{$t('labels.lots.lot_spec_balance')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.amount" :tabindex="20"
                 v-digits-after-decimal="{numberOfDigits: 3}"
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.amount) }"
                 placeholder="">
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.measure_type" :max-height="200" :tabindex="21"
                       placeholder="Choose measure" :options="measure_types"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.measure_type || orderItemData.measure_type.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.diff" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.product_type')}}</label>
          <multiselect v-model="orderItemData.m3_formula" :max-height="200" :tabindex="22"
                       placeholder="Choose profile. descr." label="name" track-by="key" :options="shapeType"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.m3_formula || orderItemData.m3_formula.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.pricePerm3')}}</label>
          <input class="form-control" v-model="orderItemData.price_per_unit" :tabindex="23"
                 v-digits-after-decimal="{numberOfDigits: 2}"
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.price_per_unit) }"
                 placeholder="Enter price per unit">
        </b-col>
        <b-col>
          <label>{{$t('labels.common.currency')}}</label>
          <input class="form-control" v-model="orderItemData.currency" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.purpose')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.quantity_packets')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.peace_per_package')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-model="orderItemData.purpose" :max-height="200" :tabindex="24"
                       placeholder="Choose purpose" label="name" track-by="key" :options="purposes"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.number_of_packages"
                 v-replace-with-positive
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist" :tabindex="25"
                 placeholder="Enter number of pack.">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.package_size"
                 v-replace-with-positive
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist" :tabindex="26"
                 placeholder="Enter pack size">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.pack_descr')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.quality_desc')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.notes')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-model="orderItemData.baling" :max-height="200" :tabindex="27"
                       placeholder="Choose pack. descr." label="name" track-by="id"
                       :options="packageDescriptions"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.quality_desc" :max-height="200" :tabindex="28"
                       placeholder="Choose quality desc." label="name" track-by="id" :options="qualityDesc"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <b-form-textarea v-model="orderItemData.notes" :tabindex="29"
                           placeholder="Enter notes">
          </b-form-textarea>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <span v-if="orderItemData.related_packages_exist" class="red-text">You can not edit PO item with related packages</span>
        <b-btn size="sm" variant="success" @click="saveItem('save')"
               :disabled="!isActiveOrderItem || orderItemData.related_packages_exist">
          {{$t('buttons.common.save')}}
        </b-btn>
        <b-btn size="sm" variant="success" @click="saveItem('add_another')">
          {{$t('buttons.common.save_add_more')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import {
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { DATE_FORMAT } from '@/constants';

  export default {
    props: ['purchaseOrderID'],
    components: {
      Multiselect,
      Datepicker
    },
    data() {
      return {
        showCollapse: false,
        isNewItem: true,
        width_limit: '',
        length_limit: '',
        thickness_limit: '',
        lotsForSelect: [],
        orderItemData: {
          lot: '',
          wood: [],
          thickness_nominal: null,
          thickness_actual: null,
          thickness_stock: null,
          width_nominal: null,
          width_actual: null,
          width_stock: null,
          length_nominal: null,
          length_actual: null,
          length_stock: null,
          quality: '',
          purpose: null,
          humidity: '',
          measure_type: '',
          amount: '',
          price_per_unit: '',
          currency: '',
          package_size: null,
          number_of_packages: null,
          diff: '',
          baling: '',
          quality_desc: '',
          delivery_term: '',
          notes: '',
          profile_desc: '',
          m3_formula: {key: 'm3_common', name: 'sawn/planed timber'},
          sales_order: '',
          related_packages_exist: false
        },
        searchData: {
          text: '',
          status: 'active'
        }
      }
    },
    methods: {
      saveItem(actionType) {
        const saveData = {
          ...this.orderItemData,
          purchase_order: this.purchaseOrderID,
          amount: this.orderItemData.amount,
          lot: this.orderItemData.lot ? this.orderItemData.lot.id : '',
          quality: this.orderItemData.quality ? this.orderItemData.quality.id : '',
          m3_formula: this.orderItemData.m3_formula ? this.orderItemData.m3_formula.key : null,
          wood: this.orderItemData.wood ? this.orderItemData.wood.id : '',
          quality_desc: this.orderItemData.quality_desc ? this.orderItemData.quality_desc.id : '',
          baling: this.orderItemData.baling ? this.orderItemData.baling.id : '',
          delivery_term: this.orderItemData.delivery_term ? moment(this.orderItemData.delivery_term).format(DATE_FORMAT) : '',
          profile_desc: this.orderItemData.profile_desc ? this.orderItemData.profile_desc.id : '',
          purpose: this.orderItemData.purpose ? this.orderItemData.purpose.key : '-',
          sales_order: this.orderItemData.sales_order ? this.orderItemData.sales_order.id : ''
        };
        if (this.checkTWL()) {
          if (this.isNewItem) {
            this.$http.post(`purchase/order_items/`, saveData)
              .then(handlerResponse).then((response) => {
              this.$notify(setNotifyData('Success', 'Order item has been created!', 'success'));
              this.$store.dispatch('purchaseOrderItems/loadOrderItems', {order_id: this.purchaseOrderID});
              this.$root.$emit('updatePurchaseOrderInfo', {id: this.purchaseOrderID});
              if (actionType === 'add_another') {
                this.orderItemData = response;
                this.cleanChangedParamsFromLot();
                this.$http.get(`purchase/lots/${this.orderItemData.lot.id}/`).then(handlerResponse).then((response) => {
                  this.orderItemData.diff = response.diff;
                });
              } else if (actionType === 'update_and_add') {
                this.orderItemData = response;
                this.cleanChangedParamsFromLot();
                this.isNewItem = false;
              } else {
                this.$refs['createOrderItemModal'].hide();
              }
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            })
          } else {
            this.$http.put(`purchase/order_items/${this.orderItemData.id}/`, saveData).then(handlerResponse).then(() => {
              this.$notify(setNotifyData('Success', 'Order item has been saved!', 'success'));
              this.$store.dispatch('purchaseOrderItems/loadOrderItems', {order_id: this.purchaseOrderID});
              this.$root.$emit('updatePurchaseOrderInfo', {id: this.purchaseOrderID});
              if (actionType === 'add_another') {
                this.isNewItem = true;
                this.saveItem('update_and_add');
              } else {
                this.$refs['createOrderItemModal'].hide();
              }
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            });
          }
        }
      },
      cleanChangedParamsFromLot() {
        this.orderItemData.length_nominal = '';
        this.orderItemData.length_actual = '';
        this.orderItemData.length_stock = '';
        this.orderItemData.amount = 0;
      },
      searchLot() {
        this.$http.get(`purchase/lots/search_by_description/`, {params: this.searchData})
          .then(handlerResponse).then((response) => {
          this.lotsForSelect = response;
        }).catch((error) => {
          console.log(error);
          notificationsRenderer(error.body, 'error');
        })
      },
      autoComplete(event) {
        this.$http.get(`purchase/lots/${event.id}/`).then(handlerResponse).then((response) => {
          delete response.delivery_term;
          delete response.amount;
          delete response.notes;
          delete response.id;
          this.orderItemData = {...this.orderItemData, ...response};
          this.setLimits();
        });
      },
      autoCompleteLength() {
        this.orderItemData.length_actual = this.orderItemData.length_nominal;
        this.orderItemData.length_stock = this.orderItemData.length_nominal;
      },
      checkTWL() {
        if (Number(this.orderItemData.thickness_nominal) < Number(this.orderItemData.thickness_nominal_from) || Number(this.orderItemData.thickness_nominal) > Number(this.orderItemData.thickness_nominal_to) || !this.orderItemData.thickness_nominal) {
          this.$notify(setNotifyData('', 'Thickness is incorrect', 'error'));
          return false
        } else if (Number(this.orderItemData.width_nominal) < Number(this.orderItemData.width_nominal_from) || Number(this.orderItemData.width_nominal) > Number(this.orderItemData.width_nominal_to) || !this.orderItemData.width_nominal) {
          this.$notify(setNotifyData('', 'Width is incorrect', 'error'));
          return false
        } else if (Number(this.orderItemData.length_nominal) < Number(this.orderItemData.length_nominal_from) || Number(this.orderItemData.length_nominal) > Number(this.orderItemData.length_nominal_to) || !this.orderItemData.length_nominal) {
          this.$notify(setNotifyData('', 'Length is incorrect', 'error'));
          return false
        } else {
          return true
        }
      },
      setLimits() {
        if (this.orderItemData.length_nominal_from !== '' && this.orderItemData.width_nominal_from !== '' && this.orderItemData.thickness_nominal_from !== ''
          && this.orderItemData.length_nominal_to && this.orderItemData.width_nominal_to && this.orderItemData.thickness_nominal_to) {
          this.length_limit = `from ${this.orderItemData.length_nominal_from} to  ${this.orderItemData.length_nominal_to} `;
          this.width_limit = `from ${this.orderItemData.width_nominal_from} to ${this.orderItemData.width_nominal_to} `;
          this.thickness_limit = `from ${this.orderItemData.thickness_nominal_from} to ${this.orderItemData.thickness_nominal_to} `;
        } else {
          this.width_limit = '';
          this.length_limit = '';
          this.thickness_limit = '';
        }
      },
      setDefaults() {
        //set default Quality as "синева до 15%"
        this.orderItemData.quality_desc = this.qualityDesc.find(e => e.id === 2);
        //set default Product type as sawn/plane timber
        this.orderItemData.m3_formula = this.shapeType.find(e => e.key === 'm3_common');
      }
    },
    async beforeMount() {
      this.$store.cache.dispatch('woodware/getWood');
      this.$store.cache.dispatch('woodware/getQualitiesList');
      this.$store.cache.dispatch('woodware/getProfiles');
      this.$store.cache.dispatch('woodware/loadHumidityList');
      this.$store.dispatch('purchaseOrderItems/loadPurposes');
      this.$store.dispatch('purchaseOrderItems/loadPackageDescriptions');
      this.$store.dispatch('salesOrders/loadSalesOrders', {status_name: 'final'});
      await this.$store.cache.dispatch('generic/loadShapeType');
      await this.$store.dispatch('purchaseOrderItems/loadQualityDescriptions');
      this.setDefaults();
    },
    mounted() {
      this.$root.$on('openCreateOrderItemModal', (payLoad) => {
        if (this.$refs['createOrderItemModal']) {
          this.isNewItem = payLoad.isNewItem;
          this.orderItemData = {...payLoad};
          this.setLimits();
          if (this.isNewItem) {
            this.setDefaults();
          }
          this.searchLot();
          this.$refs['createOrderItemModal'].show();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openCreateOrderItemModal');
    },
    computed: {
      ...mapState('woodware', ['wood', 'qualities_list', 'measure_types', 'profiles', 'humidity_list']),
      ...mapState('generic', ['shapeType']),
      ...mapState('purchaseOrderItems', ['packageDescriptions', 'qualityDesc', 'purposes']),
      ...mapState('salesOrders', ['salesOrders']),
      title() {
        return this.isNewItem ? `${this.$i18n.t('modal_dialogs.purchase_order_item.add_order_item')}` : `${this.$i18n.t('modal_dialogs.purchase_order_item.edit_order_item')}`;
      },
      isActiveOrderItem() {
        return (this.orderItemData.status === 'active' || this.isNewItem) ? true : false;
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modals/PurchaseOrderItemModal.vue